import { axiosInstance } from 'src/modules/api';
import { IApiResponse } from './shared.interface';

const PROFILE = '/api/Profile';

export function profile() {
  return axiosInstance.get<IApiResponse<IProfile>>(PROFILE);
}

export function getProfileById(id: string) {
  return axiosInstance.get<IApiResponse<IProfile>>(`${PROFILE}/${id}`);
}

export const enum Gender {
  Unspecified = 1,
  Female = 2,
  Male = 3,
};

export interface IProfile {
  isActive:      boolean;
  name:          string;
  surname:       string;
  nameEn:        string;
  surnameEn:     string;
  userName:      string;
  emailAddress:  string;
  phoneNumber:   string;
  timezone:      string;
  gender:        Gender;
  birthMonthDay: string;
  occupation:    string;
  introduction:  string;
  languages:     string[];
  residences:    string[];
  interests:     Array<{ id: number, name: string}>;
  email:         string;
  profilePictureId: string;
  houseName:     string;
}


// WEBPACK FOOTER //
// ./src/crud/profile.crud.ts